// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Step_step__feNyJ {
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 1;
}
.Step_step__feNyJ .Step_step-checkbox__jzWn8 {
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.Step_step__feNyJ .Step_step-checkbox__jzWn8 .Step_selected__tu\\+84 {
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: orange;
  margin: auto;
  z-index: 2;
}
.Step_step__feNyJ .Step_step-title__Tw7LS {
  margin-left: 16px;
  font-size: 16px;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/Stepper/Step/Step.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;AACJ;AACI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AACR;AACQ;EACI,WAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,UAAA;AACZ;AAGI;EACI,iBAAA;EACA,eAAA;EACA,WAAA;AADR","sourcesContent":[".step {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    z-index: 1;\n\n    .step-checkbox {\n        height: 16px;\n        width: 16px;\n        border-radius: 8px;\n        background-color: #fff;\n        display: flex;\n        align-items: center;\n\n        .selected {\n            height: 8px;\n            width: 8px;\n            border-radius: 4px;\n            background-color: orange;\n            margin: auto;\n            z-index: 2;\n        }\n    }\n\n    .step-title {\n        margin-left: 16px;\n        font-size: 16px;\n        color: #fff;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"step": `Step_step__feNyJ`,
	"step-checkbox": `Step_step-checkbox__jzWn8`,
	"selected": `Step_selected__tu+84`,
	"step-title": `Step_step-title__Tw7LS`
};
export default ___CSS_LOADER_EXPORT___;
